export default {
  // Titles
  currencyTokenContract: "Currency/Token Contract:",
  label: "Label:",
  time: "Time:",
  functionSwitch: "Function Switch:",
  sameTimeSameIP: "Same Time Same IP",

  // Options
  all: "All",
  pleaseSelect: "Please Select",

  // Date picker
  startDate: "Start Date",
  endDate: "End Date",

  // Function switch options
  surveyData: "Survey Data",
  firstInflow: "First Inflow",

  // Function switch tooltips
  surveyDataTooltip: "Can expand related data from uploaded survey files",
  firstInflowTooltip: "Expand to show addresses of first main currency inflow",

  // Label tooltips
  exchangeUserAddressTooltip:
    "Expanded addresses only show addresses with exchange-related labels",
  maliceTypeTooltip:
    "Expanded addresses only show addresses with malicious labels",

  // Success messages
  currencyModifiedSuccess: "Currency modified successfully",
  labelModifiedSuccess: "Label modified successfully",
  timeModifiedSuccess: "Time modified successfully",
  switchModifiedSuccess: "Switch modified successfully",
};
